import { FILL_LIST_ACTION_TYPE } from "../../utils/constants"


const initialState = [];

function fillReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case FILL_LIST_ACTION_TYPE:
      return [...state, payload];
    
    default:
      return state;
  }
};

export default fillReducer;